import { useEffect, useState } from "react";
/**
 * Активна ли сейчас вкладка (пользователь смотрит на страницу).
 * Синхронный чекер — можно звать вне React-дерева (напр. из zustand-стора в
 * момент WS-события). SSR-безопасен: без `document` считаем неактивной.
 */
export function isPageActive() {
    return typeof document !== "undefined" && document.visibilityState === "visible";
}
/**
 * React-хук: реактивно отслеживает активность вкладки через `visibilitychange`.
 * Пригодится в UI; стор использует синхронный `isPageActive` напрямую.
 */
export function usePageActive() {
    const [active, setActive] = useState(() => isPageActive());
    useEffect(() => {
        if (typeof document === "undefined")
            return;
        const onChange = () => setActive(isPageActive());
        document.addEventListener("visibilitychange", onChange);
        return () => document.removeEventListener("visibilitychange", onChange);
    }, []);
    return active;
}
